import { render, staticRenderFns } from "./GlobalConfigUpdateDialogBulkyGoodsSurcharge.vue?vue&type=template&id=2c1e34bc&scoped=true"
import script from "./GlobalConfigUpdateDialogBulkyGoodsSurcharge.vue?vue&type=script&lang=ts"
export * from "./GlobalConfigUpdateDialogBulkyGoodsSurcharge.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1e34bc",
  null
  
)

export default component.exports